import { gql } from "apollo-angular";
import { CBF } from "./content-block";
import { CBFF } from "./content-block-full";

export const  CBRRF = gql`
  fragment CBRRF on ContentBlockWithRightRailCallout {
    sys {
      id
    }
    isPzd
    backgroundColor {
      color
    }
    contentBlockCollection(limit:2){
      items {
        ... CBF
      }
    }
    rightRailBoxesCollection(limit:6){
      items {
        ... CBFF
      }
    }
    disclaimer {
      disclaimer
    } 
}
${CBF}
${CBFF}`;
